import { Drawer } from '@chakra-ui/react';

const SidebarSubHeaderCloseButton = () => (
  <Drawer.CloseTrigger data-testid="notes-sidebar-close-btn" variant="ghost" />
);

export default SidebarSubHeaderCloseButton;
